import styles from './loader.module.css';

function Loader({ isLoading }: { isLoading: boolean }) {
  return (
    <div
      className={styles.loaderContainer}
      style={{ display: isLoading ? 'block' : 'none' }}
    >
      <div className={styles.loader} role="status" aria-label="Loading">
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </div>
    </div>
  );
}

export default Loader;
